import utils from '../utils';

let share_no = utils.createRndStrId();
export default { share_no };
